import Vue from 'vue'
import loadingUtil from './index.vue'

const LoadingConstructor = Vue.extend(loadingUtil)

const instance = new LoadingConstructor({
    el: document.createElement('div')
})

instance.show = false
const loading = {
    show() {
        instance.show = true
        document.body.appendChild(instance.$el)
    },
    hide() {
        instance.show = false
    }
}

export default {
    install() {
        if (!Vue.$showLoading) {
            Vue.$showLoading = loading
        }
        Vue.mixin({
            created() {
                this.$showLoading = Vue.$showLoading
            }
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/components/Loading/index.js